import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { ApplicationFilter, ApplicationViewModel, UpdateApplicationStatus } from 'src/app/core/models/application.model';
import { APPLICATION_SENT_EMAIL, APPLICATION_STATUS_TYPES } from 'src/app/core/models/enum.model';
import { Event } from 'src/app/core/models/event.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { EventService } from 'src/app/core/services/event.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
  styleUrls: ['./application-list.component.scss']
})
export class ApplicationListComponent implements OnInit {
  eventApplications: ApplicationViewModel[] = [];
  filteredEventApplications: ApplicationViewModel[] = [];
  tableCardList: ApplicationViewModel[] = [];
  eventId = '';
  event = new Event();
  assetsPath = ASSETS_PATH;
  excelPath = null;
  totalRow = 0;
  rowPerPage = 25;
  currentPageNum = 0;
  filters = new ApplicationFilter();
  applicationStatusTypes = APPLICATION_STATUS_TYPES;
  applicationEmailStatusTypes = APPLICATION_SENT_EMAIL;
  selectedApplications = [];

  constructor(private alertService: AlertService,
    private loadingService: LoadingService,
    private applicationService: ApplicationService,
    private eventService: EventService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    if (this.route.snapshot.params.id) {
      this.eventId = this.route.snapshot.params.id;
      this.filters.eventId = this.route.snapshot.params.id;
      this.getEventApplications(this.eventId);
      this.getEvent(this.eventId);
      if (localStorage.getItem('applicationFilters') ) {        
        this.filters = JSON.parse(localStorage.getItem('applicationFilters'));
        this.filterResults();
      }
    }
  }

  getEventApplications(id: string){
    this.applicationService.getEventApplications(id).subscribe(response => {
      if (response.success) {
        this.eventApplications = this.filteredEventApplications = response.applications;
        this.tableCardList = this.filteredEventApplications.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
      }
      else {
        this.alertService.alert('Hata!', 'Etkinlik başvuruları alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  getEvent(id: string) {
    this.eventService.getEventById(id).subscribe(response => {
      if (response.success) {
        this.event = response;
      }
      else {
        this.alertService.alert('Hata!', 'Etkinlik alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  filterResults() {
    console.log(this.filters);
    localStorage.setItem('applicationFilters', JSON.stringify(this.filters));
    this.loadingService.setLoading(true);
    this.eventService.filterApplications(this.filters).subscribe(response => {
      if (response.success) {
        console.log(response);
        this.currentPageNum = 0;
        this.eventApplications = this.filteredEventApplications = response.applications;
        this.tableCardList = this.filteredEventApplications.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
        this.alertService.notification('Başarılı!', 'Başvurular başarıyla filtrelendi.', 'success');
      }
      else {
        this.alertService.alert('Hata!', 'Başvurular alınamadı.', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  resetFilters() {
    this.filters = {
      fullName: null,
      email: null,
      role: null,
      startDate: null,
      endDate: null,
      status: null,
      lastSentEmail: null,
      eventId: this.eventId
    };
    localStorage.removeItem('applicationFilters');
    this.loadingService.setLoading(true);
    this.getEventApplications(this.eventId);
  }

  incrementPage(){
    if ((this.currentPageNum+1)*this.rowPerPage < this.filteredEventApplications.length) {
      this.currentPageNum += 1;
      this.loadingService.setLoading(true);
      this.tableCardList = this.filteredEventApplications.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
      this.loadingService.setLoading(false);
    }
  }

  decrementPage(){
    if (this.currentPageNum>0){
      this.currentPageNum -= 1;
      this.loadingService.setLoading(true);
      this.tableCardList = this.filteredEventApplications.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
      this.loadingService.setLoading(false);
    }
  }

  setFirstPage(){
    this.currentPageNum = 0;
    this.loadingService.setLoading(true);
    this.tableCardList = this.filteredEventApplications.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
    this.loadingService.setLoading(false);
  }

  setLastPage(){
    if ((this.filteredEventApplications.length / this.rowPerPage) > Math.floor((this.filteredEventApplications.length / this.rowPerPage))){
      this.currentPageNum =  Math.floor((this.filteredEventApplications.length / this.rowPerPage));
    }
    else {
      this.currentPageNum =  Math.floor((this.filteredEventApplications.length / this.rowPerPage)) - 1;
    }
    this.loadingService.setLoading(true);
    this.tableCardList = this.filteredEventApplications.slice(this.rowPerPage*this.currentPageNum, this.rowPerPage*(this.currentPageNum+1));
    this.loadingService.setLoading(false);
  }

  getApplicationStatus(status: number) {
    if (status === undefined || status === null) {
      return "";
    }
    let value = this.applicationStatusTypes.filter(x => x.code === status);

    if (value !== undefined && value !== null) {
      try{
        return value[0].text;
      }
      catch {
        return "";
      }
    }
  }

  getApplicationEmailStatus(status: number) {
    if (status === undefined || status === null) {
      return "";
    }
    let value = this.applicationEmailStatusTypes.filter(x => x.code === status);

    if (value !== undefined && value !== null) {
      try{
        return value[0].text;
      }
      catch {
        return "";
      }
    }
  }

  excelExport(){
    this.loadingService.setLoading(true);
    this.eventService.filterExcelApplications(this.filters).subscribe(response => {
      if (response.success) {
        this.excelPath = response.excelPath;
        this.alertService.alert('Başarılı!', 'Başvuru listesi başarıyla excel olarak oluşturuldu.', 'success');
      }
      else {
        this.alertService.alert('Hata!', 'Başvuru listesi excel dosyası oluşturulamadı!', 'error');
      }
      this.loadingService.setLoading(false);
    });
  }

  onChange(id:string, isChecked: boolean) {
    if(isChecked) {
      this.selectedApplications.push(id);
    } else {
      let index = this.selectedApplications.indexOf(id);
      this.selectedApplications.splice(index,1);
    }
  }

  updateStatus(value: string) {
    if (this.selectedApplications.length != 0){
      let model = new UpdateApplicationStatus();
      model.applicationIds = this.selectedApplications;
      if (value == "onayla") {
        model.status = 2;
      }
      else if (value == "reddet") {
        model.status = 3;
      }
      else if (value == "tamamla") {
        model.status = 4;
      }
      else if (value == "bekleme") {
        model.status = 5;
      }
      else if (value == "katilmadi") {
        model.status = 6;
      }
      else if (value == "sil") {
        model.status = 11;
      }
      this.loadingService.setLoading(true);
      this.applicationService.updateApplicationStatus(model).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı!', 'Seçilen başvurular güncellendi.', 'success');
          this.filterResults();
        }
        else {
          this.alertService.alert('Hata!', 'Seçilen başvurular güncellenemedi!', 'error');
          this.filterResults();
        }
        this.loadingService.setLoading(false);
      });
    }
  }

  sendEmail(id: string){
    this.loadingService.setLoading(true);
    this.applicationService.sendApplicationEmail(id).subscribe(response => {
      if (response.success) {
        this.alertService.alert('Başarılı!', 'Seçilen başvuru için mail gönderildi.', 'success');
        this.filterResults();
      }
      else {
        this.alertService.alert('Hata!', 'Seçilen başvuru için mail gönderilemedi!', 'error');
        this.filterResults();
      }
      this.loadingService.setLoading(false);
    });
  }

}
